import { FIXED } from '../constants/constants';

/**
 * Returns discount amount for the current tariff.
 *
 * @param {{cost}} tariff
 * @param {{discount, unit}} period
 * @param {{number}} currencyRate
 * @return {number}
 */
export default (tariff, period, currencyRate) => {
    let result = 0;
    const unit = period?.unit?.toLowerCase() ?? period?.interval_discount_unit?.toLowerCase();
    const discount = period?.discount ?? period?.interval_discount;
    if (unit === 'percent') {
        result = tariff?.cost * discount / 100;
    } else if (unit?.toUpperCase() === FIXED) {
        result = discount * currencyRate;
    }
    return result;
}
